module.exports = __webpack_public_path__ + "static/media/formals.a9f5b4ce.jpg";